var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 383,
    viewBox: "0 0 418 383",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3528 85.5234H399.113C409.029 85.5234 417.705 92.9603 417.705 102.876V247.896C417.705 257.811 409.029 265.248 399.113 265.248H348.294V382.999H69.411V265.248H17.3528C7.43689 265.248 0 257.811 0 247.896V102.876C0 92.9603 7.43689 85.5234 17.3528 85.5234ZM355.731 121.468C363.168 121.468 368.126 126.426 368.126 133.863C368.126 140.061 363.168 146.258 355.731 146.258C349.534 146.258 343.337 140.061 343.337 133.863C343.337 126.426 349.534 121.468 355.731 121.468ZM327.223 187.161H90.4822V361.928H327.223V187.161Z",
    fill: "#FEB05A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4102 79.3269V0H348.294V79.3269H327.222V21.0712H90.4814V79.3269H69.4102Z",
    fill: "#FEB05A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.033 215.67H302.434V236.741H114.033V215.67Z",
    fill: "#FEB05A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.033 280.123H302.434V301.194H114.033V280.123Z",
    fill: "#FEB05A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintFill);
export default __webpack_public_path__ + "static/media/print-fill.b536ea028a7b9d2941c4346bd7b596ac.svg";
export { ForwardRef as ReactComponent };